import { render, staticRenderFns } from "./companiesPage.vue?vue&type=template&id=5a36fb51&"
import script from "./companiesPage.vue?vue&type=script&lang=ts&"
export * from "./companiesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports